function addTotal(cartTotal) {
  let newCartTotal = cartTotal.replace(/\$/g, "");
  newCartTotal = parseFloat(newCartTotal);
  if (localStorage.getItem("realift:hasMeasurements") == "true") {
    if (typeof window.gtag === "function") {
      gtag("event", "realsize_add_total", {
        event_category: "RealSize",
        event_label: "RealSize Add Total",
        value: newCartTotal,
        send_to: "G-24765BCH66",
        use_beacon: true,
      });
      gtag("event", "realsize_add_transaction", {
        event_category: "RealSize",
        event_label: "RealSize Add Transaction",
        value: 1,
        send_to: "G-24765BCH66",
        use_beacon: true,
      });
    }
  }
} 